export default __webpack_public_path__ + "static/media/platformDeviceIcon6.d4a0235e.webp";